import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { GET } from "../../helpers/apiHelper";
import * as action from "./actions";
// import { storeLog } from "../log/actions";
import { unauthorizeUser } from "../../helpers/utility";

export const getListState = (state) => state.importLogApp.list;

const loadImportLogListAsync = async (query) => GET(`/import-log?${query}`);

function* loadImportLogList({ payload }) {
  try {
    const list = yield select(getListState);
    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "orderby",
        value: list.orderBy,
      },
      {
        name: "sortedby",
        value: list.sortedBy,
      },
      {
        name: "limit",
        value: payload.limit,
      },
      {
        name: "deleteFlag",
        value: encodeURIComponent(payload.deleteFlag),
      },
    ];

    if (payload.startDate) {
      param.push({ name: "startDate", value: payload.startDate });
    }
    if (payload.endDate) {
      param.push({ name: "endDate", value: payload.endDate });
    }
    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
        ],
      ];
    }
    const response = yield call(loadImportLogListAsync, param.map((t) => `${t.name}=${t.value}`).join("&"));
    yield put(action.loadImportLogListSuccess(response));
  } catch (error) {
    console.log('loadImportLogList error', error)
    // yield call(unauthorizeUser(error));
    yield put(action.loadImportLogListError(error));
  }
}

export function* watchLoadImportLogList() {
  yield takeEvery(action.IMPORT_LOG_GET_LIST, loadImportLogList);
}
export default function* rootSaga() {
  yield all([
    fork(watchLoadImportLogList),
  ]);
}
